import { Component, Input } from '@angular/core';
import { CommunityModel } from '@shared/models/CommunityModel';
import { ScratchModel } from '@shared/models/ScratchModel';

@Component({
    selector: 'app-lucky-scratch-layout',
    templateUrl: './lucky-scratch-layout.component.html',
    styleUrls: ['./lucky-scratch-layout.component.scss']
})
export class LuckyScratchLayoutComponent {

    @Input() scratch: ScratchModel;
    @Input() title: string = 'Tu Raspa de la Suerte';
    @Input() showPrizesPanel: boolean = false;
    @Input() community: CommunityModel = null;
}
